import { render, staticRenderFns } from "./SelectAvailableSession.vue?vue&type=template&id=674db25e&"
import script from "./SelectAvailableSession.vue?vue&type=script&lang=ts&"
export * from "./SelectAvailableSession.vue?vue&type=script&lang=ts&"
import style0 from "./SelectAvailableSession.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports